import React from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import { Typography, Container } from "@mui/material";
import { allColors } from "../../constants";
import "../tableStyle.css";

const data = [
  { id: 1, name: "UK Local", value: "4p", value2: "18p" },
  { id: 2, name: "Antigua & Barbuda", value: "34.5p", value2: "16p" },
  { id: 3, name: "Antigua & Barbuda Mobile", value: "44.5p", value2: "16p" },
  { id: 4, name: "Ghana Mobile", value: "45.5p", value2: "16p" },
  { id: 5, name: "Hong Kong", value: "9p", value2: "12p" },
  { id: 6, name: "Hungary Mobile", value: "20p", value2: "16p" },
  { id: 7, name: "Ireland", value: "9p", value2: "16p" },
  { id: 8, name: "Ireland Dublin", value: "9p", value2: "16p" },
  { id: 9, name: "Ireland Mobile", value: "29p", value2: "14p" },
  { id: 10, name: "Iceland", value: "8p", value2: "14p" },
  { id: 11, name: "Korea South", value: "12p", value2: "16p" },
  { id: 12, name: "GUERNSEY", value: "2p", value2: "20p" },
  { id: 13, name: "Australia", value: "9p", value2: "16p" },
  { id: 14, name: "Australia Mobile", value: "22.5p", value2: "16p" },
  { id: 15, name: "Austria", value: "12p", value2: "16p" },
  { id: 16, name: "Belgium", value: "9p", value2: "16p" },
  { id: 17, name: "Belgium Mobile", value: "31p", value2: "16p" },
  { id: 18, name: "Bulgaria", value: "13.5p", value2: "16p" },
  { id: 19, name: "Bermuda", value: "13p", value2: "16p" },
  { id: 20, name: "Canada", value: "9p", value2: "16p" },
  { id: 21, name: "Switzerland", value: "37p", value2: "16p" },
  { id: 22, name: "Switzerland Mobile", value: "37p", value2: "16p" },
  { id: 23, name: "Cyprus Mobile", value: "13p", value2: "16p" },
  { id: 24, name: "Germany", value: "9p", value2: "14p" },
  { id: 25, name: "Germany Mobile", value: "33.5p", value2: "16p" },
  { id: 26, name: "Denmark Mobile", value: "28p", value2: "16p" },
  { id: 27, name: "Spain", value: "9p", value2: "16p" },
  { id: 28, name: "Spain Mobile", value: "21p", value2: "16p" },
  { id: 29, name: "Fiji Mobile", value: "50p", value2: "16p" },
  { id: 30, name: "France", value: "9p", value2: "16p" },
  { id: 31, name: "France Mobile", value: "13.5p", value2: "16p" },
  { id: 32, name: "Israel Mobile", value: "6.5p", value2: "16p" },
  { id: 33, name: "Italy", value: "9p", value2: "16p" },
  { id: 34, name: "Italy Mobile", value: "36p", value2: "16p" },
  { id: 35, name: "Netherlands", value: "9p", value2: "14p" },
  { id: 36, name: "Netherlands Mobile", value: "35.5p", value2: "16p" },
  { id: 37, name: "Norway", value: "9p", value2: "16p" },
  { id: 38, name: "Norway Mobile", value: "14p", value2: "16p" },
  { id: 39, name: "New Zealand", value: "9p", value2: "32p" },
  { id: 40, name: "New Zealand Mobile", value: "32p", value2: "16p" },
  { id: 41, name: "Pakistan", value: "23.5p", value2: "14p" },
  { id: 42, name: "Pakistan Mobile", value: "26.5p", value2: "16p" },
  { id: 43, name: "Papua New Guinea Mobile", value: "£1.46", value2: "16p" },
  { id: 44, name: "Poland Mobile", value: "18p", value2: "16p" },
  { id: 45, name: "Portugal", value: "9p", value2: "16p" },
  { id: 46, name: "Portugal Mobile", value: "22p", value2: "16p" },
  { id: 47, name: "Sweden", value: "9p", value2: "11p" },
  { id: 48, name: "Sweden Mobile", value: "13p", value2: "16p" },
  {
    id: 49,
    name: "Turkish Republic of Northern Cyprus",
    value: "23p",
    value2: "16p",
  },
  { id: 50, name: "USA", value: "9p", value2: "14p" },
  { id: 51, name: "USA Premium", value: "25p", value2: "16p" },
  { id: 52, name: "South Africa", value: "10p", value2: "16p" },
  { id: 53, name: "South Africa Mobile", value: "36.5p", value2: "16p" },
];

const InternationalCallCharges = () => {
  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: "80px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35", md: "55px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          International Call Charges
        </Typography>

        <table className="simple-table">
          <thead>
            <tr>
              <th>Call Charges – Pay as you go only</th>
              <th>Per minute</th>
              <th>Call Set Up Charge</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.value}</td>
                <td>{item.value2}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Container>
    </NavigationDrawer>
  );
};

export default InternationalCallCharges;
